export default __webpack_public_path__ + "static/media/ProductPageImage01.d34e455a.jpg";